import Swal from 'sweetalert2';

export  let moreInfo = ({ name, review, mobile_number, LinkdIn }) => {
    Swal.fire({
        title: name,
        text: review,
        showCloseButton: true,
        showCancelButton: true,
        icon: 'info',
        confirmButtonText: 'Open LinkedIn',
        cancelButtonText: 'Call',
        buttonsStyling: false,
        reverseButtons: true,
        customClass: {
            popup: 'instructorSwal',
            confirmButton: 'btn btn-secondary',
            cancelButton: 'btn btn-dark'
        }
    }).then((result) => {
        if (result.isConfirmed) {
            if (LinkdIn) window.open(LinkdIn, '_blank', 'noopener,noreferrer');
            else {
                Swal.fire({
                    title: 'LinkedIn not available',
                    text: 'This instructor does not have a LinkedIn link yet.',
                    icon: 'warning',
                    buttonsStyling: false,
                    confirmButtonText: 'OK',
                    customClass: { popup: 'instructorSwal', confirmButton: 'btn btn-dark' }
                });
            }
        } else if (result.dismiss === Swal.DismissReason.cancel) {
            if (!mobile_number) {
                Swal.fire({
                    title: 'Phone not available',
                    text: 'This instructor does not have a phone number yet.',
                    icon: 'warning',
                    buttonsStyling: false,
                    confirmButtonText: 'OK',
                    customClass: { popup: 'instructorSwal', confirmButton: 'btn btn-dark' }
                });
                return;
            }

            Swal.fire({
                title: 'Call instructor',
                text: mobile_number,
                icon: 'question',
                showCloseButton: true,
                showCancelButton: true,
                confirmButtonText: 'Call now',
                cancelButtonText: 'Close',
                buttonsStyling: false,
                customClass: {
                    popup: 'instructorSwal',
                    confirmButton: 'btn btn-dark',
                    cancelButton: 'btn btn-outline-dark'
                }
            }).then((result) => {
                if (result.isConfirmed) {
                    window.open(`tel:${mobile_number}`);
                }
            });
        }
    });
};